// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"7370a990","453":"cd7ec2a5","591":"2cf636d2","869":"f446c310","962":"3a65cc4e"}[chunkId] + ".chunk.js";
};